const SELECTOR_FOCUSABLE =
  ':is(button, a[href], input:not([type="hidden"]), select, textarea, [tabindex]):not([disabled], [tabindex^="-"]), [role="gridcell"]';

export function getAllFocusableElementsOf(el: Element): HTMLElement[] {
  return Array.from(el.querySelectorAll<HTMLElement>(SELECTOR_FOCUSABLE));
}
